<template>
	<div style="height: 100%">
		<el-tabs v-model="activeTab">
			<el-tab-pane label="列表" name="list">
				<el-form :inline="true" label-width="68px" class="searchListInput">
					<el-form-item label="用户编号" prop="userCode">
						<el-input v-model="queryParams.userCode" placeholder="请输入用户编号" clearable size="small"
							style="width: 150px" @keyup.enter.native="handleQuery" />
					</el-form-item>
					<el-form-item label="用户名称" prop="userName">
						<el-input v-model="queryParams.userName" placeholder="请输入用户名称" clearable size="small"
							style="width: 150px" @keyup.enter.native="handleQuery" />
					</el-form-item>
					<!--                    <el-form-item label="手机号" prop="phone">-->
					<!--                        <el-input-->
					<!--                                v-model="queryParams.phone"-->
					<!--                                placeholder="请输入手机号"-->
					<!--                                clearable-->
					<!--                                size="small"-->
					<!--                                style="width: 150px"-->
					<!--                                @keyup.enter.native="handleQuery"-->
					<!--                        />-->
					<!--                    </el-form-item>-->
					<el-form-item label="角色" prop="roleId">
						<el-select placeholder="请选择" v-model="queryParams.roleId" size="small" clearable>
							<el-option v-for="item in roleOptions" :key="item.key" :label="item.value"
								:value="item.key">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item class="mb8">
						<el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery"
							class="elButtonSearch">搜索
						</el-button>
						<el-button type="primary" icon="el-icon-plus" size="mini" @click="handleAdd">新增
						</el-button>
					</el-form-item>
				</el-form>

				<el-table v-loading="loading" :data="tableData" border @row-dblclick="handleTableRow"  height="98%" style="width: fit-content">
					<!--                    <el-table-column type="selection" width="55" align="center"/>-->
					<el-table-column label="用户编号" align="center" prop="userCode" width="150" />
					<el-table-column label="用户名称" align="center" prop="userName" width="150" />
					<el-table-column label="角色" align="center" prop="roleId" width="150" />
					<el-table-column label="是否为超级管理员" align="center" prop="adminFlag" width="150" />
					<el-table-column label="手机号" align="center" prop="phone" width="150" />
					<el-table-column label="操作" align="center" width="450">
						<template slot-scope="scope">
							<el-button size="mini" type="text" icon="el-icon-edit"
								@click="handleUpdatePermission(scope.row)">权限设置</el-button>
							<el-button size="mini" type="text" icon="el-icon-user" @click="setAdmin(scope.row)">设置为超级管理员
							</el-button>
							<el-button size="mini" type="text" icon="el-icon-user"
								@click="cancelAdmin(scope.row)">取消超级管理员</el-button>
						</template>
					</el-table-column>
				</el-table>

				<div class="block">
					<el-pagination v-show="total > 0" @size-change="handleQuery" @current-change="handleQuery"
						:current-page.sync="queryParams.current" :page-sizes="[10, 20, 40, 60, 80, 100]"
						:page-size.sync="queryParams.size" layout="total, sizes, prev, pager, next, jumper"
						:total="total">
					</el-pagination>
				</div>
			</el-tab-pane>
			<el-tab-pane label="详情" name="detail">
				<el-form :inline="true" label-width="68px" class="searchListInput">
					<el-form-item class="mb8">
						<el-button type="primary" icon="el-icon-plus" size="mini" @click="handleAdd">新增
						</el-button>
						<el-button type="primary" icon="el-icon-finished" size="mini" @click="save"
							class="elButtonSearch">保存
						</el-button>
						<el-button type="primary" icon="el-icon-delete" size="mini" @click="handleDelete"
							class="elButtonSearch">删除
						</el-button>
					</el-form-item>
				</el-form>

				<el-form ref="form" :model="form" :rules="rules" label-width="100px">
					<el-row>
						<el-col :span="8">
							<el-form-item label="手机号" prop="phone">
								<el-input v-model="form.phone" placeholder="手机号" @blur="phoneBlur" />
							</el-form-item>
							<el-form-item label="用户编号" prop="userCode">
								<el-input v-model="form.userCode" placeholder="用户编号" disabled />
							</el-form-item>
							<el-form-item label="用户名称" prop="userName">
								<el-input v-model="form.userName" placeholder="用户名称" />
							</el-form-item>
							<el-form-item label="角色" prop="roleId">
								<el-select placeholder="请选择" v-model="form.roleId" size="small" clearable>
									<el-option v-for="item in roleOptions" :key="item.key" :label="item.value"
										:value="item.key">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
	import {
		selectList,
		add,
		detail,
		remove,
		setAdmin,
		cancelAdmin
	} from '../../api/system/basicUser';
	import {
		translateObjectEmptyAttributeToNull
	} from '../../untils/func';
	import {
		selectRole
	} from '../../api/comboboxLoad';

	export default {
		name: 'Spring',
		data() {
			//验证手机号的规则;
			var checkMobile = (rule, value, cb) => {
				// 验证手机号的正则表达式
				const regMobile =
					/^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
				if (regMobile.test(value)) {
					return cb();
				}
				cb(new Error('请输入合法的手机号'));
			};
			return {
				total: 0,
				activeTab: 'list',
				// 遮罩层
				loading: true,
				// 字典表格数据
				tableData: [],

				userId: null,
				userCode: '',

				roleOptions: [],

				// 查询参数
				queryParams: {
					current: 1,
					size: 10,
					userName: '',
					userCode: '',
					phone: '',
					roleId: null,
				},
				// 表单参数
				form: {
					phone: '',
					userCode: '',
				},
				// 表单校验
				rules: {
					// userCode: [
					//   { required: true, message: '用户编号不能为空', trigger: 'blur' },
					// ],
					userName: [{
						required: true,
						message: '用户名称不能为空',
						trigger: 'blur'
					}, ],
					phone: [{
							required: true,

							message: '手机号不能为空',
							trigger: 'blur',
						},
						{
							validator: checkMobile,
							message: '请输入正确的手机号码',
							trigger: 'blur',
						},
					],
				},
			};
		},

		created() {
			this.init();
		},

		methods: {
			async init() {
				const response = await selectRole().then();
				this.roleOptions = response.data;

				await this.handleQuery();
			},

			async handleQuery() {
				this.loading = true;
				let param = this.queryParams;
				param = translateObjectEmptyAttributeToNull(param);
				const response = await selectList(param).then();
				this.tableData = response.data;
				this.total = response.total;
				this.loading = false;
			},
			async save() {
				// this.$refs.form.validate((valid) => {
				//   if(valid){}
				// });
				const response = await add(this.form).then();
				const id = response.data;
				this.msgSuccess('保存成功');
				await this.viewDetail(id);
				await this.handleQuery();
			},

			async handleTableRow(row) {
				this.activeTab = 'detail';
				await this.viewDetail(row.id);
			},

			async viewDetail(id) {
				const response = await detail({
					id: id
				}).then();
				this.form = response.data;
			},
			async handleAdd() {
				this.form = {};
				this.activeTab = 'detail';
			},
			async handleDelete() {
				if (this.form.id == undefined) {
					return;
				}
				await this.$confirm('确定要删除吗?', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				}).then();
				await remove(this.form.id).then();
				this.msgSuccess('删除成功');
				await this.handleAdd();
				await this.handleQuery();
			},
			handleUpdatePermission(row) {
				this.$router.push({
					path: '/mainWindow/userModule',
					query: {
						userId: row.id
					},
				});
			},
			// 设置为超级管理员
			async setAdmin(row) {
				let query = {
					id: row.id
				}
				await setAdmin(query);
				this.msgSuccess('设置成功');
				await this.handleQuery();
			},
			// 取消超级管理员
			async cancelAdmin(row){
				await this.$confirm('确定要取消吗?', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				}).then();
				let query = {
					id: row.id
				}
				await cancelAdmin(query);
				this.msgSuccess('取消成功');
				await this.handleQuery();
			},
			phoneBlur() {
				this.form.userCode = this.form.phone;
			},
		},
	};
</script>

<style scoped lang="scss">
	.el-tabs {
		padding: 0 10px;
		height: 100%;

		.el-tab-pane {
			height: calc(100% - 75px);
		}
	}

	.elButtonSearch {
		background: #00b741;
		border: 1px solid #00b741;

		&:hover {
			background: #39d636;
			border: 1px solid #39d636;
		}
	}

	.searchListInput {
		.el-input__inner {
			&::placeholder {
				color: #838689;
			}
		}

		.el-date-editor .el-range-input {
			&::placeholder {
				color: #838689;
			}
		}

		.el-form-item {
			margin-bottom: 0.25rem;
		}
	}

</style>
